import Vue from 'vue'
import Router from 'vue-router'

import PageGame from '@/pages/page-game'
import PageIndex from '@/pages/page-index'

Vue.use(Router)

export default new Router({
  // mode: 'history',

  routes: [
    {
      path: '/game/:id/:isSpymaster',
      name: 'game.show',
      component: PageGame,
      props: true
    },
    {
      path: '/',
      name: 'index',
      component: PageIndex
    }
  ]
})
